import type { ActivityEmailCreated } from "../types";
import { EmailItem } from "../mail/EmailItem";

/** An email in the company activity feed; a click shows the whole message. */
export const ActivityLogEmail = ({
  activity,
}: {
  activity: ActivityEmailCreated;
}) => <EmailItem email={activity.email} />;
